import { t as _ } from "./isDefined-fMi6eQ4r.js";
import { r as q } from "./theme-B90C-74v.js";
import { d as m } from "./utilities-D50JxcQi.js";
import { t as z } from "./mergeClassNames-BHKm1BNi.js";
import { Fragment as D, jsx as t, jsxs as R } from "react/jsx-runtime";
import { Button as S } from "@base-ui/react/button";
import { Avatar as f } from "@base-ui/react/avatar";
var U = "_root_1i3fb_1", w = "_avatarPulsing_1i3fb_1", E = "_image_1i3fb_84", G = "_fallback_1i3fb_90", H = "_icon_1i3fb_94", n = {
  root: U,
  avatarPulsing: w,
  image: E,
  fallback: G,
  icon: H
}, X = ({ src: h, name: s, colorSeed: l = s, size: k = "md", shape: A = "square", variant: v = "soft", icon: i, color: N, backgroundColor: x, borderColor: y, pulsing: B = !1, disabled: u = !1, nativeButton: C = !0, onClick: g, className: I, style: d, render: o, "aria-label": P, ...T }) => {
  const a = q(), e = s?.trim().charAt(0).toUpperCase(), j = e ? N ?? m({
    string: l ?? "",
    variant: 12,
    theme: a
  }) : a.font.color.tertiary, F = e ? x ?? m({
    string: l ?? "",
    variant: v === "outline" ? 5 : 4,
    theme: a
  }) : a.background.transparent.light, b = y ?? (e ? m({
    string: l ?? "",
    variant: 6,
    theme: a
  }) : void 0), c = _(g), p = _(i) && typeof i != "boolean" && i !== "";
  return /* @__PURE__ */ t(f.Root, {
    ...T,
    onClick: g,
    "aria-label": P ?? (c ? s?.trim() || "Avatar" : void 0),
    "data-size": k,
    "data-shape": A,
    "data-pulsing": B || void 0,
    "data-disabled": u || void 0,
    "data-clickable": c || void 0,
    className: z(n.root, I),
    style: (r) => ({
      "--ui-avatar-color": j,
      "--ui-avatar-background": p ? "inherit" : r.imageLoadingStatus === "loaded" ? "none" : F,
      "--ui-avatar-border": v === "outline" && r.imageLoadingStatus !== "loaded" && b ? `1px solid ${b}` : "none",
      ...typeof d == "function" ? d(r) : d
    }),
    render: c ? (r, L) => /* @__PURE__ */ t(S, {
      ...r,
      disabled: u,
      nativeButton: C,
      render: typeof o == "function" ? ($) => o($, L) : o
    }) : o,
    children: p ? /* @__PURE__ */ t("span", {
      className: n.icon,
      "aria-hidden": !0,
      children: i
    }) : /* @__PURE__ */ R(D, { children: [/* @__PURE__ */ t(f.Image, {
      src: h ?? void 0,
      alt: "",
      className: n.image
    }), /* @__PURE__ */ t(f.Fallback, {
      className: n.fallback,
      "aria-hidden": !0,
      children: e || "-"
    })] })
  });
};
export {
  X as t
};
